export default __webpack_public_path__ + "static/media/eye-open.ee3b1724.svg";